import React from 'react';

const Dashboard = React.lazy(() => import('./views/Home/Dashboard'));
const Login = React.lazy(() => import('./views/Users/Login'));
const SignUp = React.lazy(() => import('./views/Users/SignUp'));
const UpdatePassword = React.lazy(() => import('./views/Users/UpdatePassword'));
const Facturas = React.lazy(() => import('./views/Facturas/Facturas'));
const Documentos = React.lazy(() => import('./views/Clientes/Documentos'));

const routes = [
  { path: '/', name: 'Inicio', exact: true },
  { path: '/dashboard', name: 'Cuadro de mandos', exact: true, component: Dashboard }, 
  { path: '/login', name: 'Login', exact: true, component: Login }, 
  { path: '/sign-up', name: 'Registro', exact: true, component: SignUp }, 
  { path: '/update-password', name: 'Update your password', exact: true, component: UpdatePassword }, 
  { path: '/facturas', name: 'Facturas', exact: true, component: Facturas }, 
  { path: '/otros-documentos', name: 'Modelo 347', exact: true, component: Documentos }, 
]

export default routes;
